module.exports = __webpack_public_path__ + "static/media/french-fries.e904d1eb.jpg";